export default function TrustAsMarkupFilter(moduleName) {
    angular.module(moduleName || 'app')
        .filter('trustAsMarkup', trustAsMarkup);

    trustAsMarkup.$inject = ['$sce'];
    function trustAsMarkup($sce) {
        return function (val) {
            if (!!val) {
                val = val.replace(/style="float\: left;"/g, 'class="left rte"');
                val = val.replace(/style="float\: right;"/g, 'class="right rte"');
                val = val.replace(/<iframe/g, '<div class="flex-video widescreen"><iframe');
                val = val.replace(/<\/iframe>/g, '</iframe></div>');
            }
            return $sce.trustAs('html', val);
        };
    }
} 